import { useCallback } from 'react';
import { useLogMarketAnalyticsEvent } from '../../../hooks/useLogMarketAnalyticsEvent';

export const useLogSearchKeyword = () => {
  const logMarketAnalytics = useLogMarketAnalyticsEvent();

  return useCallback<(keyword: string) => void>(
    keyword => {
      logMarketAnalytics({
        name: 'SEARCH_KEYWORD',
        channel: ['ablylog'],
        analytics: {
          SEARCH_KEYWORD: keyword,
        },
      });
    },
    [logMarketAnalytics],
  );
};
